import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><inlineCode parentName="p">{`PostHog.FeatureFlags.check/2`}</inlineCode>{` is the main function for checking a feature flag in Elixir. More documentation on it can be found in the `}<a parentName="p" {...{
        "href": "https://hexdocs.pm/posthog/PostHog.FeatureFlags.html"
      }}>{`HexPM Docs`}</a>{`.`}</p>
    <h4 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`iex> PostHog.FeatureFlags.check("example-feature-flag-1", "user123")
{:ok, true}
`}</code></pre>
    <p>{`It will attempt to take `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` from the context if it's not provided.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`iex> PostHog.set_context(%{distinct_id: "user123"})
:ok
iex> PostHog.FeatureFlags.check("example-feature-flag-1")
{:ok, true}
`}</code></pre>
    <h4 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`iex> PostHog.FeatureFlags.check("example-feature-flag-1", "user123")
{:ok, "variant2"}
`}</code></pre>
    <h3 {...{
      "id": "errors"
    }}>{`Errors`}</h3>
    <p>{`We'll return an error if the feature flag doesn't exist.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`iex> PostHog.FeatureFlags.check("example-feature-flag-3", "user123")
{:error, %PostHog.UnexpectedResponseError{message: "Feature flag example-feature-flag-3 was not found in the response", response: ...}}
`}</code></pre>
    <p>{`You can also use `}<inlineCode parentName="p">{`PostHog.FeatureFlags.check!/2`}</inlineCode>{` if you're feeling adventurous or running a script and prefer errors to be raised instead.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      